"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractLsosProjectInfo = void 0;
var validateLsosProject_1 = require("./validateLsosProject");
function extractLsosProjectInfo(packageJson) {
    var _a, _b, _c, _d, _e;
    var npmName = packageJson.name.split("/")[0];
    var projectName = (_a = packageJson === null || packageJson === void 0 ? void 0 : packageJson.lsos) === null || _a === void 0 ? void 0 : _a.projectName;
    var donationText = (_c = (_b = packageJson === null || packageJson === void 0 ? void 0 : packageJson.lsos) === null || _b === void 0 ? void 0 : _b.donationReminder) === null || _c === void 0 ? void 0 : _c.text;
    var minNumberOfAuthors = (_e = (_d = packageJson === null || packageJson === void 0 ? void 0 : packageJson.lsos) === null || _d === void 0 ? void 0 : _d.donationReminder) === null || _e === void 0 ? void 0 : _e.minNumberOfAuthors;
    var lsosProjectInfo = {
        npmName: npmName,
        projectName: projectName,
        donationText: donationText,
        minNumberOfAuthors: minNumberOfAuthors,
    };
    var propSources = {
        npmName: "name",
        projectName: "lsos.projectName",
        donationText: "lsos.donationReminder.text",
        minNumberOfAuthors: "lsos.donationReminder.minNumberOfAuthors",
    };
    validateLsosProject_1.validateLsosProject(lsosProjectInfo, propSources);
    return lsosProjectInfo;
}
exports.extractLsosProjectInfo = extractLsosProjectInfo;
//# sourceMappingURL=extractLsosProjectInfo.js.map